package eu.bontlab.models

import eu.bontlab.util.Res

interface PortfolioItem {
    val image: String
    val title: String
    val description: String
}

enum class Mapdroid(
    override val image: String,
    override val title: String,
    override val description: String
): PortfolioItem  {
    One(
        image = Res.Image.portfolio1,
        title = "Live session tracking",
        description = "With live data analysis"
    ),
    Two(
        image = Res.Image.portfolio2,
        title = "Manual session planning",
        description = "With optional \"Interest Points\""
    ),
    Three(
        image = Res.Image.portfolio3,
        title = "Live/Manual tacks Archive",
        description = "With session type icon"
    ),
    Four(
        image = Res.Image.portfolio4,
        title = "Track details",
        description = "Speed diagram and Altimetric profile"
    ),
    Five(
        image = Res.Image.portfolio5,
        title = "Compass tool",
        description = "With heading degrees"
    ),
    Six(
        image = Res.Image.portfolio6,
        title = "Direction Arrow",
        description = "With GPS-Precision/Distance data"
    ),
    Seven(
        image = Res.Image.portfolio7,
        title = "Draw on map tool",
        description = "With pen color/size selectors"
    ),
    Eight(
        image = Res.Image.portfolio8,
        title = "Multi Measure Units support",
        description = "Live conversions"
    )
}

enum class Diarydroid(
    override val image: String,
    override val title: String,
    override val description: String
): PortfolioItem  {
    One(
        image = Res.Image.portfolio9,
        title = "Diary/Agenda items",
        description = "Grouped by date"
    ),
    Two(
        image = Res.Image.portfolio10,
        title = "Diary items filtering",
        description = "By category icon"
    ),
    Three(
        image = Res.Image.portfolio11,
        title = "Diary items filtering",
        description = "By date range"
    ),
    Four(
        image = Res.Image.portfolio12,
        title = "Diary note details",
        description = "With attached images/audios"
    ),
    Five(
        image = Res.Image.portfolio13,
        title = "Diary note details",
        description = "With audio recording tool"
    ),
    Six(
        image = Res.Image.portfolio14,
        title = "Search by text tool",
        description = "(at least 3 characters)"
    ),
    Seven(
        image = Res.Image.portfolio15,
        title = "Diary items deletion",
        description = "By date range"
    ),
    Eight(
        image = Res.Image.portfolio16,
        title = "Entering diary note",
        description = "With mood icon and rating stars"
    )
}

enum class Spinplayer(
    override val image: String,
    override val title: String,
    override val description: String
): PortfolioItem  {
    One(
        image = Res.Image.portfolio17,
        title = "Music/audio files list",
        description = "With option to load video files"
    ),
    Two(
        image = Res.Image.portfolio18,
        title = "Reorderable playlist",
        description = "During playback"
    ),
    Three(
        image = Res.Image.portfolio19,
        title = "Playlist with video item",
        description = "During playback"
    ),
    Four(
        image = Res.Image.portfolio20,
        title = "Playlist details",
        description = "Tracks list and durations"
    ),
    Five(
        image = Res.Image.portfolio21,
        title = "Track details",
        description = "With single playback option"
    ),
    /*
    Six(
        image = Res.Image.portfolio22,
        title = "Direction Arrow",
        description = "With GPS-Precision/Distance data"
    ),
    Seven(
        image = Res.Image.portfolio23,
        title = "Draw on map tool",
        description = "With pen color/size selectors"
    ),
    Eight(
        image = Res.Image.portfolio24,
        title = "Multi Measure Units support",
        description = "Live conversions"
    )
    */
}

enum class FantasyMaze3d(
    override val image: String,
    override val title: String,
    override val description: String
): PortfolioItem  {
    One(
        image = Res.Image.portfolio25,
        title = "Level 1",
        description = ""
    ),
    Two(
        image = Res.Image.portfolio26,
        title = "Level 2",
        description = ""
    ),
    Three(
        image = Res.Image.portfolio27,
        title = "Level 3",
        description = ""
    ),
    Four(
        image = Res.Image.portfolio28,
        title = "Level 4",
        description = ""
    ),
    Five(
        image = Res.Image.portfolio29,
        title = "Level 5",
        description = ""
    ),
    Six(
        image = Res.Image.portfolio30,
        title = "Level 6",
        description = ""
    ),
    Seven(
        image = Res.Image.portfolio31,
        title = "Level 7",
        description = ""
    ),
    Eight(
        image = Res.Image.portfolio32,
        title = "Level 8",
        description = ""
    )
}